import React, { useState, useEffect } from 'react';
import { Grid, FormControl, TextField } from '@mui/material';
import muiInputStyles from '../../../uiComponents/MuiInput/MuiInputStyles';

const MetadataBiochemical = ({
  metadata,
  formValues,
  errors,
  handleUploadInputChange,
  validateTextField,
  hasAttemptedNext,
  onReady
}) => {
  const classes = muiInputStyles();

  const [localValue, setLocalValue] = useState(formValues.workflowName || '');
  const [localError, setLocalError] = useState('');

  useEffect(() => {
    if (onReady) onReady();
  }, [onReady]);

  const handleTextChange = (e) => {
    const { value } = e.target;
    setLocalValue(value);
  };

  const handleTextBlur = (e) => {
    const { value } = e.target;
    const trimmedValue = value.trim();
    const fieldMeta = metadata.find(f => f.name === 'workflowName');
    const label = fieldMeta ? fieldMeta.label : 'Workflow Name';
    // Suppress the "required" message on blur until the user has attempted to
    // proceed at least once. Non-empty values are still validated on blur.
    const error = (trimmedValue.length === 0 && !hasAttemptedNext)
      ? ''
      : validateTextField('workflowName', trimmedValue, label);

    setLocalError(error);

    setLocalValue(trimmedValue);
    handleUploadInputChange({ target: { name: 'workflowName', value: trimmedValue } });
  };

  return (
    <div className="Metadata">
      <form onSubmit={(e) => e.preventDefault()}>
        <Grid container spacing={3} className="dashGridContainer">
          <Grid item xs={3}></Grid>
          <Grid item xs={6} sx={{ p: 1.5 }}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                size="small"
                name="workflowName"
                id="workflowName"
                className={classes.muiInputs}
                value={localValue}
                onChange={handleTextChange}
                onBlur={handleTextBlur}
                variant="outlined"
                label="Workflow Name"
                required
                error={!!(errors && errors.workflowName) || !!localError}
                helperText={errors && errors.workflowName ? errors.workflowName : localError}
                inputProps={{ maxLength: 25 }}
                FormHelperTextProps={{
                  style: { color: "#DA190B" },
                }}
                autoComplete="off"
              />
            </FormControl>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default MetadataBiochemical;